import CaretDown16 from '@carbon/icons-react/es/caret--down/16';
import CaretRight16 from '@carbon/icons-react/es/caret--right/16';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Button } from 'components/atoms/button';
import { ProjectTemplateData } from 'data/templates/projects';

const CollapseSpacer = css`
  height: 24px;
  min-width: 24px;
  width: 24px;
`;

const CollapseButton = styled(Button)`
  ${CollapseSpacer};
`;

const BlockedSpanSpacer = styled.span`
  display: inline-block;
  ${CollapseSpacer};
`;

export const CustomExpandIcon: FC<{
  expanded: boolean;
  record: ProjectTemplateData;
  onExpand(
    record: ProjectTemplateData,
    event: React.MouseEvent<HTMLElement, MouseEvent>,
  ): void;
}> = ({ expanded, record, onExpand }) => {
  return record.children?.length ? (
    <CollapseButton
      className={`js__collapse_icon ${
        expanded ? 'js__collapse' : 'js__expand'
      }`}
      size="small"
      type="text"
      onClick={(e) => onExpand(record, e)}
      icon={expanded ? <CaretDown16 /> : <CaretRight16 />}
    />
  ) : (
    <BlockedSpanSpacer />
  );
};
